// src/passiveSystem.js
// Implementación de efectos laterales según ENGINE_GACHA_SPEC_v1

export class PassiveSystem {
  constructor(activePassives = []) {
    // Array de objetos ResidentCard obtenidos del Roster
    // Cada uno contiene { id, mentor, level, affinity }
    this.passives = activePassives;
  }

  // Verifica si el equipo actual tiene una pasiva específica
  getPassiveEffect(type) {
    const found = this.passives.find(p => p.mentor?.passive_effect?.type === type);
    return found ? found.mentor.passive_effect.params : null;
  }

  // Aplica el buffer de tiempo al límite base
  applyTimeBuffer(baseMs) {
    const params = this.getPassiveEffect("time_buffer");
    if (!params) return baseMs;
    const extraMs = (params.seconds || 0) * 1000;
    return baseMs + extraMs;
  }

  // Mitiga el daño a la estabilidad [NEW]
  applyStabilityMitigation(damage) {
    const params = this.getPassiveEffect("stability_mitigation");
    if (!params) return damage;
    const reduction = params.reduction || 0;
    return Math.max(0, damage * (1 - reduction));
  }

  // Aumenta la recuperación de estabilidad [NEW]
  applyStabilityRecoveryMultiplier(recovery) {
    const params = this.getPassiveEffect("stability_recovery");
    if (!params) return recovery;
    const multiplier = params.multiplier || 1;
    return recovery * multiplier;
  }

  // Reduce la acumulación de fatiga (Burnout) [NEW]
  applyFatigueReduction(burnoutGain) {
    const params = this.getPassiveEffect("fatigue_reduction");
    if (!params) return burnoutGain;
    const reduction = params.reduction || 0;
    return burnoutGain * (1 - reduction);
  }

  // Bonus de Créditos [NEW]
  applyCreditsBonus(baseCredits) {
    const params = this.getPassiveEffect("credits_bonus");
    if (!params) return baseCredits;
    const multiplier = params.multiplier || 1;
    return Math.round(baseCredits * multiplier);
  }

  // Bonus de XP [NEW]
  applyXPBonus(baseXP) {
    const params = this.getPassiveEffect("xp_bonus");
    if (!params) return baseXP;
    const multiplier = params.multiplier || 1;
    return Math.round(baseXP * multiplier);
  }

  // Desbloquea pistas contextuales (hints)
  canUnlockHint(scope) {
    const params = this.getPassiveEffect("hint_unlock");
    return params ? params.hint_scope === scope : false;
  }
}